





















import { Vue, Component } from "vue-property-decorator";

@Component({
  components: {}
  
})
export default class AppMain extends Vue {
    get key () {
      return this.$route.path + Math.random()
    }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/homenew/components/AppMain.vue